// API CLIENT  ACTIONS:
export const SET_NODES = "SET_NODES";
export const SET_EDGES = "SET_EDGES";

export const UPDATE_EDGES = "UPDATE_EDGES";
export const UPDATE_NODES = "UPDATE_NODES";

export const SET_NODE_MODAL = "SET_NODE_MODAL";
export const MODIFY_NODE = "MODIFY_NODE";

export const SET_IS_ON_CONNECTION = "SET_IS_ON_CONNECTION";
export const SET_WINDOWS_LIST = "SET_WINDOWS_LIST";
export const SET_WINDOW_FIELDS = "SET_WINDOW_FIELDS";
export const SET_LAYOUT_FIELDS = "SET_LAYOUT_FIELDS";
export const SET_VARIABLES_PAYLOAD = "SET_VARIABLES_PAYLOAD";
export const SET_VARIABLE_FIELDS = "SET_VARIABLE_FIELDS";
export const SET_FORMULA_FIELD_DATA = "SET_FORMULA_FIELD_DATA";
export const SET_RESOURCES_LIST = "SET_RESOURCES_LIST";
export const UPDATE_RESOURCES_LIST = "UPDATE_RESOURCES_LIST";
export const CLEAR_RESOURCES_LIST = "CLEAR_RESOURCES_LIST";
export const UPDATE_NODE_MODAL = "UPDATE_NODE_MODAL";
export const SET_ARRAY_OBJECT_FIELDS = "SET_ARRAY_OBJECT_FIELDS";
export const SET_LOOKUP_DETAILS = "SET_LOOKUP_DETAILS";
export const UPDATE_LOOKUP_DETAILS="UPDATE_LOOKUP_DETAILS";
export const UPDATE_LOOKUP_DETAILS_MULTI = "UPDATE_LOOKUP_DETAILS_MULTI";
export const SET_INPUT_VARIABLES ="SET_INPUT_VARIABLES";
export const SET_FORMULA_FIELD_DETAILS="SET_FORMULA_FIELD_DETAILS";

export const SET_ACTION_ELEMENTS_DETAILS ="SET_ACTION_ELEMENTS_DETAILS";
export const SET_ACTION_API_DATA = "SET_ACTION_API_DATA";
export const CLEAR_ACTION_API_DATA ="CLEAR_ACTION_API_DATA";
export const SET_ASSIGNMENT_ARRAY_FIELD_DETAILS="SET_ASSIGNMENT_ARRAY_FIELD_DETAILS";

export const SET_DIRECTORY_FIELD_DETAILS="SET_DIRECTORY_FIELD_DETAILS";

